// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"fd4da7ba","141":"b7a1e709","213":"a920bf4e","239":"c4846873","422":"21563b31","430":"2742728b","455":"0c9214ec"}[chunkId] + ".chunk.js";
};